/** The texts of manual and nested collections (COL-06 to COL-10), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const collectionsEn = {
  studyCount: '{count} studies',
  studyCount_one: '1 study',
  newCollectionKind: 'What the new collection holds',
  dynamicCollectionChoice: 'What matches filters',
  dynamicCollectionChoiceHint: 'A saved search: it always holds the studies that match its filters now.',
  manualCollectionChoice: 'Studies you choose',
  manualCollectionChoiceHint: 'It holds the studies you put into it, from the images page or any list of studies.',
  manualCollection: 'Manual',
  frozenCollection: 'Frozen',
  frozenDetails: 'Annotations and exports',
  manualCollectionIntro: 'Holds the studies put into it. Choose studies on the images page and add them here; the filters only narrow what it shows.',
  insideCollection: 'Inside {name}',
  parentCollection: 'Inside',
  topLevel: 'Top level',
  addToCollection: 'Add to collection',
  addedToCollection: 'Added to {name}.',
  removeFromCollection: 'Remove from collection',
  freezeCollection: 'Freeze',
  freezeCollectionHint: 'Keeps the studies it holds now as a frozen collection, which never changes',
  freezeChecked: 'Freeze with checked sets',
  freezeCheckedHint: 'Keeps its studies with the annotations of everyone who checked them, as far as you see them, and how often each did; studies nobody checked stay out',
  collectionGoal: 'Goal',
  setGoal: 'Set a goal',
  changeGoal: 'Change goal',
  saveGoal: 'Save goal',
  removeGoal: 'Remove goal',
  goalHint: 'The filters its studies are to meet, for example “checked by me twice” or, for two readers, “checked twice by anyone”.',
  goalProgress: '{met} of {total} studies meet it',
  goalShow: 'Show',
  goalAll: 'All',
  goalMet: 'Meet it',
  goalUnmet: 'Still open',
  frozenName: '{name} on {date}',
  outsideCollections: 'Studies in none of my collections',
  newCollectionFromSelection: 'New collection with these studies…',
  siteCollection: 'Site',
  collectionOwner: 'Belongs to',
  collectionMine: 'Me',
  collectionForSite: 'The site {site}',
  grantCollections: 'Only these site collections',
  grantCollectionsHint: 'None chosen: all of the site’s studies. Collections with filters on annotations cannot be granted.',
  grantAllStudies: 'all studies',
  coverUnavailable: 'Images unavailable: their site’s storage does not answer',
}

export const collectionsDe: Record<keyof typeof collectionsEn, string> = {
  studyCount: '{count} Studien',
  studyCount_one: '1 Studie',
  newCollectionKind: 'Was die neue Sammlung enthält',
  dynamicCollectionChoice: 'Was zu Filtern passt',
  dynamicCollectionChoiceHint: 'Eine gespeicherte Suche: Sie enthält immer die Studien, die jetzt zu ihren Filtern passen.',
  manualCollectionChoice: 'Studien, die Sie wählen',
  manualCollectionChoiceHint: 'Sie enthält die Studien, die Sie hineinlegen, von der Bilderseite oder aus jeder Liste von Studien.',
  manualCollection: 'Manuell',
  frozenCollection: 'Eingefroren',
  frozenDetails: 'Annotationen und Exporte',
  manualCollectionIntro: 'Enthält die hineingelegten Studien. Wählen Sie Studien auf der Bilderseite und legen Sie sie hier ab; die Filter grenzen nur ein, was sie zeigt.',
  insideCollection: 'In {name}',
  parentCollection: 'In',
  topLevel: 'Oberste Ebene',
  addToCollection: 'Zur Sammlung hinzufügen',
  addedToCollection: 'Zu {name} hinzugefügt.',
  removeFromCollection: 'Aus der Sammlung nehmen',
  freezeCollection: 'Einfrieren',
  freezeCollectionHint: 'Behält die jetzt enthaltenen Studien als eingefrorene Sammlung, die sich nie ändert',
  freezeChecked: 'Mit geprüften Annotationen einfrieren',
  freezeCheckedHint: 'Behält ihre Studien mit den Annotationen aller, die sie geprüft haben, soweit Sie sie sehen, und wie oft; Studien, die niemand geprüft hat, bleiben draußen',
  collectionGoal: 'Ziel',
  setGoal: 'Ziel setzen',
  changeGoal: 'Ziel ändern',
  saveGoal: 'Ziel speichern',
  removeGoal: 'Ziel entfernen',
  goalHint: 'Die Filter, die ihre Studien erfüllen sollen, zum Beispiel „zweimal von mir geprüft“ oder, für zwei Lesende, „zweimal geprüft von allen“.',
  goalProgress: '{met} von {total} Studien erfüllen es',
  goalShow: 'Zeigen',
  goalAll: 'Alle',
  goalMet: 'Erfüllt',
  goalUnmet: 'Noch offen',
  frozenName: '{name} am {date}',
  outsideCollections: 'Studien in keiner meiner Sammlungen',
  newCollectionFromSelection: 'Neue Sammlung mit diesen Studien …',
  siteCollection: 'Standort',
  collectionOwner: 'Gehört',
  collectionMine: 'mir',
  collectionForSite: 'dem Standort {site}',
  grantCollections: 'Nur diese Sammlungen des Standorts',
  grantCollectionsHint: 'Keine gewählt: alle Studien des Standorts. Sammlungen mit Filtern auf Annotationen lassen sich nicht freigeben.',
  grantAllStudies: 'alle Studien',
  coverUnavailable: 'Bilder nicht verfügbar: Der Speicher ihres Standorts antwortet nicht',
}
